import { render, staticRenderFns } from "./Trips.vue?vue&type=template&id=808e01c0&scoped=true&"
import script from "./Trips.vue?vue&type=script&lang=js&"
export * from "./Trips.vue?vue&type=script&lang=js&"
import style0 from "./Trips.vue?vue&type=style&index=0&id=808e01c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808e01c0",
  null
  
)

export default component.exports